

<template>
    <div class="modal fade"
        :class="[className]"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        :aria-label="title"
        ref="modalElement">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            style="max-width:750px">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{title}}</h4>
                    <button type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>
                        <slot name="body" :on-dismiss="handleDismiss">{{body}}</slot>
                        <slot></slot>
                    </p>
                </div>
                <div class="modal-footer"
                    v-if="showFooter">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { Modal } from "bootstrap";
const props = defineProps<{
    showModal?: boolean;
    title?: string;
    body?: string;
    showFooter?: boolean;
    className?: string;
}>();

let modalElement = ref(null);
let modelObject = null;

const state = ref(false);

onMounted(() => {
    modelObject = new Modal(modalElement.value);

    modalElement.value.addEventListener("hidden.bs.modal", (event) => {
        emit("dismiss");
        state.value = false;
    });
});

const emit = defineEmits<{
    (event: "dismiss"): void;
}>();

function handleDismiss() {
    emit("dismiss");
}
function _show() {
    state.value = true;
    modelObject.show();
}

function _hide() {
    state.value = false;
    modelObject.hide();
    emit("dismiss");
}

watch(
    () => props.showModal,
    (showModal, prevShowModal) => {
        state.value = showModal;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

defineExpose({ show: _show });
</script>